module.exports = __webpack_public_path__ + "img/inquiry-builder.457f0484.png";